import produce from 'immer';
import {
	FETCH_POSTCODES_FAILED,
	FETCH_POSTCODES_FULFILLED,
	FETCH_POSTCODES_PENDING,
} from '../constants/actions/postCodesActions';

const postCodesReducer = produce(
	(draft, action) => {
		switch (action.type) {
			case FETCH_POSTCODES_PENDING: {
				draft.postCodesLoading = true;
				draft.postCodesError = false;
				break;
			}
			case FETCH_POSTCODES_FULFILLED: {
				draft.postCodesLoading = false;
				draft.postCodes = action.payload.postCodes;
				draft.postCodes = action.payload.postCodes;
				draft.postCodesError = false;
				break;
			}
			case FETCH_POSTCODES_FAILED: {
				draft.postCodesLoading = false;
				draft.postCodesError = true;
				break;
			}
			default: {
				break;
			}
		}
	},
	{
		postCodes: null,
		postCodesLoading: false,
		postCodesError: false,
	}
);

export default postCodesReducer;
